/**
 * @module Directives.Invitations
 *
 */
import checkmark_green_png from 'app/images/checkmark-green.png';
import template from 'ngapp/templates/views/invitations/_space_created_phone_invitation_copy_link_modal.html';

/**
 * @class SpaceCreatedPhoneInviteCopyLinkModal
 *
 */
function Controller($scope, $q, $translate, $clipboard, toast) {
  $scope.pending = false;
  $scope.inviteLink = $scope.$props.inviteLink;
  $scope.inviteeName = $scope.$props.inviteeName;
  $scope.checkmark_green_png = checkmark_green_png;
  $scope.onDone = onDone;
  $scope.onCopyClick = onCopyClick;

  function onDone() {
    $scope.$props.modal.dismiss();
  }

  function onCopyClick(e) {
    $q.resolve($clipboard.copy($scope.inviteLink, e))
      .then(() => {
        toast.success($translate.instant('INVITATION_MODALS.COPY_LINK_MODAL.COPY_SUCCESS'));
        onDone();
      })
      .catch(() => toast.danger($translate.instant('INVITATION_MODALS.COPY_LINK_MODAL.COPY_ERROR')));
  }
}

Controller.$inject = [
  '$scope',
  '$q',
  '$translate',
  'core.services.$clipboard',
  'core.ui.toast'
];

export default {
  bindings: {
    modal: '<',
    inviteeName: '<',
    inviteLink: '<'
  },
  template,
  controller: Controller,
  controllerAs: '$props'
};
